import { render, staticRenderFns } from "./Promise.vue?vue&type=template&id=77110e06&scoped=true&"
import script from "./Promise.vue?vue&type=script&lang=js&"
export * from "./Promise.vue?vue&type=script&lang=js&"
import style0 from "./Promise.vue?vue&type=style&index=0&id=77110e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77110e06",
  null
  
)

export default component.exports